import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';

import {
  featuresCountState,
  featuresSearchOptionsSelector,
  featuresState,
  hasSelectedFeaturesFilterSelector,
  resetSelectedFeaturesSelector,
  selectedFeaturesSelector,
  selectFeaturesSelector,
  toggleFeaturesSelector,
} from '@/states/filters/features.state';

export function useFeaturesFilter() {
  const [featuresFilter, setFeaturesFilter] = useRecoilState(featuresState);
  const [featuresCount, setFeaturesCount] = useRecoilState(featuresCountState);
  const featuresSearchOptions = useRecoilValue(featuresSearchOptionsSelector);
  const toggleFeatures = useSetRecoilState(toggleFeaturesSelector);
  const selectFeatures = useSetRecoilState(selectFeaturesSelector);
  const selectedFeatures = useRecoilValue(selectedFeaturesSelector);
  const resetSelectedFeatures = useSetRecoilState(
    resetSelectedFeaturesSelector
  );
  const hasSelectedFeaturesFilter = useRecoilValue(
    hasSelectedFeaturesFilterSelector
  );

  return {
    featuresFilter,
    setFeaturesFilter,
    featuresCount,
    setFeaturesCount,
    featuresSearchOptions,
    toggleFeatures,
    selectedFeatures,
    resetSelectedFeatures,
    hasSelectedFeaturesFilter,
    selectFeatures,
  };
}
